'use strict';

bbw.service.PhotoAlbumGallerySvc = Class({

    $inject: ['$rootScope', '$fancyModal', 'growl'],

    $rootScope: undefined,
    $fancyModal: undefined,

    _themeClass: 'album-gallery',
    _template: 'album-gallery.html',

    construct: function($rootScope, $fancyModal, growl) {
        this.$rootScope = $rootScope;
        this.$fancyModal = $fancyModal;
        this._growl = growl;
    },

    showHint: function(message, enabled, event) {
        event.preventDefault();
        event.stopPropagation();
        if (!enabled) {
            return;
        }
        this._growl.info(message);
    },

    confirm: function(scope, action, args, autoconfirm) {
        var doAction = function() {
            if (this.$rootScope.$$phase) {
                scope.$evalAsync(action);
            } else {
                scope.$apply(action);
            }
        }.bind(this);
        if (autoconfirm) {
            doAction();
            return;
        }
        var childScope = this.$rootScope.$new();
        angular.extend(childScope, args);
        this.$fancyModal.open({
            scope: childScope,
            themeClass: 'confirm',
            templateUrl: bbw.templateUrl('confirm.html'),
            controller: ['$scope', function($scope) {
                $scope.ok = function() {
                    doAction();
                    $scope.$modal.close();
                };
                $scope.cancel = function() {
                    $scope.$modal.close();
                };
            }]
        })
    },

    openGallery: function(galleryControls, album, index, themeClass, template) {
        if (!album || !album.getLength()) {
            return;
        }
        var scope = this.$rootScope.$new();
        album.wireScope(scope, 'album');
        scope.index = index || 0;
        scope.showHint = this.showHint.bind(this);
        if (angular.isObject(galleryControls)) {
            scope.controls = galleryControls;
            scope.has = {};
            if (scope.controls.title) {
                scope.galleryTitle = scope.controls.title;
                delete scope.controls.title;
            }
            Object.keys(galleryControls).forEach(function(key) {
                scope.has[key] = true;
            });
            scope.confirm = function(controlAction, idx, args, autoconfirm) {
                this.confirm(scope, function() {
                    return scope.controls[controlAction].call(scope.controls, scope.album.items[idx]);
                }, args, autoconfirm);
            }.bind(this);
        } else {
            scope.controls = undefined;
            scope.has = {};
        }
        this.$fancyModal.open({
            scope: scope,
            themeClass: themeClass || this._themeClass,
            templateUrl: bbw.templateUrl(template || this._template),
            controller: ['$scope', function(scope) {
                scope.$watch('album.items.length', function(len) {
                    if (len) {
                        scope.index %= len;
                    } else {
                        scope.$modal.close();
                    }
                });
                scope.keyPressed = function(event) {
                    var handled = true;
                    switch (event.keyCode) {
                        case ngtk.tools.keyboard.keys.LEFT:
                            scope.prev();
                            break;
                        case ngtk.tools.keyboard.keys.RIGHT:
                            scope.next();
                            break;
                        case ngtk.tools.keyboard.keys.SPACE:
                            if (event.shiftKey) {
                                scope.prev();
                            } else {
                                scope.next();
                            }
                            break;
                        default:
                            handled = false;
                    }
                    if (handled) {
                        event.preventDefault();
                        event.stopPropagation();
                        scope.$safeApply();
                    }
                };
                var documentElement = angular.element(document.documentElement);
                documentElement.bind('keydown', scope.keyPressed);
                scope.hasPrev = function() {
                    return scope.index > 0;
                };
                scope.hasNext = function() {
                    return scope.index < scope.album.items.length - 1;
                };
                scope.prev = function() {
                    if (--scope.index < 0) {
                        scope.index = scope.album.items.length - 1;
                        scope.ngPinchScale = 1;
                    }
                };
                scope.next = function() {
                    scope.index = (scope.index + 1) % scope.album.items.length;
                    scope.ngPinchScale = 1;
                };
                scope.$on('$destroy', function() {
                    documentElement.unbind('keydown', scope.keyPressed);
                });
            }]
        });
    }

});
